export default __webpack_public_path__ + "static/media/AirbnbCerealExtraBold.1e9cf6ed.woff";